<template>
  <div class="h5box">
    <template v-if="!resultSuccess && !resultError">
      <div class="signUp">
        <div class="signUpIn">
          <header>
            <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/crm/images/head.jpg">
          </header>
          <section>
            <h1>宣讲报名 | "研"途有我————英美名校招生政策解析之理工篇</h1>
            <div class="blueTitle">
              <div class="detailText">
                <strong>主讲人：Faisal Akkawi</strong>
              </div>
              <div class="spanText">
                <span>美国西北大学</span>
                <span>计算机科学系</span>
                <span>教授 / 信息系统硕士项目主任</span><br>
              </div>

              <div class="time">
                <span>时间：2022/11/23 20:00-21:00</span><br>
                <span>形式：Zoom直播 </span><br>
                <span>*报名成功后，将以短信形式通知会议号</span><br>
              </div>
            </div>


            <div class="formWrapper">
              <el-form ref="rulesForm" :rules="formRules" :model="formData">
                <el-form-item label="姓名" prop="name">
                  <el-input v-model="formData.name"></el-input>
                </el-form-item>
                <el-form-item label="学校" prop="school">
                  <el-input v-model="formData.school"></el-input>
                </el-form-item>
                <el-form-item label="专业" prop="direction">
                  <el-input v-model="formData.direction"></el-input>
                </el-form-item>
                <el-form-item label="年级" prop="grade">
                  <el-select v-model="formData.grade" placeholder="请选择">
                    <el-option
                        v-for="item in gradeOptions"
                        :key="item"
                        :label="item"
                        :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="手机" prop="phone">
                  <el-input v-model="formData.phone"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                  <el-input v-model="formData.email"></el-input>
                </el-form-item>
                <el-form-item label="未来学术计划" prop="remake">
                  <el-select v-model="formData.remake" placeholder="请选择">
                    <el-option
                        v-for="item in scienceOptions"
                        :key="item"
                        :label="item"
                        :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>

              <el-button class="submitBtn" @click="submitForm">提交</el-button>
            </div>
          </section>
          <div class="footer"></div>
        </div>
      </div>
    </template>
    <el-result
        icon="success"
        title="提交成功"
        subTitle="提交成功, 请手动关闭页面"
        v-if="resultSuccess"
    >
      <template slot="extra">

      </template>
    </el-result>
    <el-result
        icon="error"
        title="提交失败"
        subTitle="提交失败, 请稍后再试"
        v-if="resultError"
    >
    </el-result>
  </div>
</template>

<script>
import {delNullProperty} from "@/utils";
import axios from "axios";

export default {
  name: "signUp",
  components: {},

  data() {
    return {
      formRules: {
        name: [{required: true, message: '请填写名字', trigger: 'blur'}],
        school: [{required: true, message: '请填写学校', trigger: 'blur'}],
        direction: [{required: true, message: '请填写专业', trigger: 'change'}],
        grade: [{required: true, message: '请选择年级', trigger: 'change'}],
        email: [{required: true, message: '请填写邮箱', trigger: 'blur'}],
        phone: [{required: true, message: '请填写手机', trigger: 'blur'}],
        remake: [{required: true, message: '请选择未来学术计划', trigger: 'blur'}]
      },
      formData: {
        name: '',
        partList: [],
        remake: ''
      },
      gradeOptions: [
        '大学一年级',
        '大学二年级',
        '大学三年级',
        '大学四年级',
        '研究生及以上'
      ],
      scienceOptions: [
        '海外升学',
        '国内升学',
        '就业'
      ],
      directionShow: false,
      // directionInput: "",
      axios: null,
      errorInfos: {
        // 存放对应输入框的报错信息，在提交的时候统一验证
        name: "",
        school: "",
        phone: "",
        email: "",
        grade: "",
        direction: "",
        remake: ""
      },
      resultSuccess: false, // 提交成功
      resultError: false
    }
  },
  created() {

    this.createAxios();
  },


  destroyed() {
    document.documentElement.style.fontSize = "16px";
  },

  methods: {
    createAxios() {
      const origin = location.hostname; //当前访问域名
      let requestBase = "";
      if (process.env.NODE_ENV === "development") {
        requestBase = process.env.VUE_APP_BASE_CRM_API_PROXY;
      } else {
        if (origin.indexOf("-testserver") > -1) {
          requestBase = process.env.VUE_APP_DEV_API;
        } else {
          requestBase = process.env.VUE_APP_MASTER_API;
        }
      }
      const config = {
        baseURL: requestBase,
        timeout: 30 * 1000, // Timeout
      };

      this.axios = axios.create(config);
    },

    directionShowPopup() { //咨询专业方向
      this.directionShow = true
    },
    // 咨询专业方向
    listenDirection(data) {
      if (data != false) {
        this.direction = data
      }
      this.directionShow = false
    },
    submitForm() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.axios
          .post(
              "/market/setMarketClueByByxjh",
              delNullProperty({
                name: this.formData.name,
                school: this.formData.school,
                phone: this.formData.phone,
                email: this.formData.email,
                grade: this.formData.grade,
                direction: this.formData.direction,
                remake: this.formData.remake,
              })
          )
          .then(({data}) => {
            // 判断错误状态
            const error = data.error;
            if (error.returnCode === 1) {
              this.$message.error(error.returnMessage);
            }
            if (error.returnCode === 0) {
              this.resultSuccess = true;
            }
            loading.close();
          })
          .catch((err) => {
            loading.close();
            this.resultError = true
          });
    }
  }
}
</script>
<style>
.el-scrollbar .el-scrollbar__bar {
  opacity: 1 !important;
}
</style>
<style scoped>
.signUp >>> .el-checkbox__label {
  display: inline-grid;
  white-space: pre-line;
  word-wrap: break-word;
  overflow: hidden;
  line-height: 20px;
  white-space: normal;
  word-break: break-all;
}

.signUp >>> .el-form-item__label {
  color: rgb(7, 0, 89);
}

.el-select {
  width: 100%;
}

.h5box {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}

.signUp {
  background-image: url("https://gecacademy.oss-cn-beijing.aliyuncs.com/crm/images/bg.jpg");
  position: absolute;
  margin: -20px;
  width: 100%;
}

.signUpIn {
  padding: 10px;
}

header {
  margin-top: 20px;
  border-radius: 15px 15px 0 0;
  overflow: hidden;
}

header img {
  width: 100%;
  margin-bottom: -4px;
}


section {
  background: #fff;
  border-radius: 0 0 15px 15px;
  padding: 20px;
}


.footer {
  height: 50px;
}

.submitBtn {
  width: 100%;
  background-color: rgb(42, 68, 166);
  color: #fff
}


.blueTitle .detailText, .spanText {
  text-align: left;
  margin-bottom: 13px;
  color: #888787;
}

.time {
  color: #555;
}

.titledesc {
  text-indent: 2em;
  margin-bottom: 13px;
}

h1, .blueTitle {
  margin-bottom: 13px;
}

.mainMake {
  text-align: center;
  margin: 20px 0;
  border-top: 1px dashed grey;
  padding: 7px 0;

}


h1 {
  color: rgb(7, 0, 89);
  font-size: 18px;
}

.el-checkbox {
  color: rgb(7, 0, 89)
}

.el-checkbox span {
  color: #999;
}
</style>
